<template>
    <div class="manage--content">

        <div class="nqt--title" :class="presentList.length||absentList.length?'':'non_list'" v-if="data != null && !mobile">
            <h1>
                {{data.courseName}}
            </h1>
        </div>

        <div class="tab">
            <button :class="{active1: tabPresent}" v-on:click="tabPresent = true" class="btn-tab">{{$t('manage.presentList')}}</button>
            <button :class="{active1: !tabPresent}" v-on:click="tabPresent = false" class="btn-tab">{{$t('manage.absentList')}}</button>
        </div>

        <template v-if="!loading">
            <!-- Cpn: Danh sách học viên có mặt -->
            <present v-if="tabPresent" :data="presentList" :isDownload="isDownload" @download="downloadListStudentPresent()"></present>

            <!-- Cpn: Danh sách học viên vắng mặt -->
            <absent v-if="!tabPresent" :data="absentList" :isDownload="isDownload" @reload="init()" @download="downloadListStudentPresent()"></absent>
        </template>

        <!-- Loading -->
        <loading class="loading--lesson nqt-pst-a" :showLoading="loading"/>
    </div>
</template>

<script>
    import { mapState, mapActions } from "vuex";

    import present from "@/components/manage/attendance/present";
    import absent from "@/components/manage/attendance/absent";
    import loading from "@/components/loading/loading";

    export default {
        data() {
            return {
                tabPresent: true,
                loading: true,
                presentList: [],
                absentList: [],
                checkStudentPresent: false,
                isDownload: false
            };
        },
        components: {
            present,
            absent,
            loading,
        },
        props: {
            data: {
                type: Object,
                default: {},
            },
        },
        computed: {
            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile,
                coursesOnline: (state) => state.manageStudent.coursesOnline,
            }),
        },
        created() {
            this.init();
        },
        methods: {

            init: async function () {

                this.loading = true;

                if (this.data) {
                    // Load data
                    this.presentList = await this.getPresentList(this.data);
                    this.absentList = await this.getAbsentList(this.data);
    
                    // Lưu vào store
                    let presentStdList = this.presentList.filter(item => item.userType == '2');
                    let absentStdList = this.absentList.filter(item => item.userType == '2');
                    this.saveDetailJoin({courseLiveId: this.data.courseLiveId, totalStudentJoin: presentStdList.length,  totalStudentNoJoin: absentStdList.length});
                }

                this.isDownload = (this.presentList.length || this.absentList.length) && !this.mobile ? true : false;

                this.loading = false;
            },

            ...mapActions("manageStudent", ["saveDetailJoin"]),

            // Lấy danh sách học viên có mặt
            getPresentList: function (param) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getLiveCourseParticipantList", {
                            courseId: param.courseLiveId,
                        })
                        .then((response) => {
                            let listStudents = [];
                            response.data.forEach(el => {
                                // if(el.userType == '2') {
                                //     listStudents.push(el)
                                // }

                                listStudents.push(el)
                            })
                            resolve(listStudents);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Lấy danh sách học viên vắng mặt
            getAbsentList: function (param) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getLiveCourseNonParticipantList", {
                            courseId: param.courseLiveId,
                        })
                        .then((response) => {
                            const students = response.data.reduce((accumulator, value) => {
                                // if (value.userType == '2') {
                                //     value['courseLiveId'] = param.courseLiveId;
                                //     accumulator.push(value);
                                // }
                                value['courseLiveId'] = param.courseLiveId;
                                accumulator.push(value);
                                return accumulator;
                            }, []);
                            resolve(students);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Export CSV
            downloadListStudentPresent() {
                let course = {};
                this.coursesOnline.forEach((val) => {
                    if (val.courseLiveId == this.data.courseLiveId) {
                        var status = "";
                        if (val.status == 2) {
                            status = this.$t("new.title8");
                        } else if (val.status == 3) {
                            status = this.$t("new.title9");
                        } else {
                            status = this.$t("new.title7");
                        }
                        val.textStatus = status;
                        course = val;
                    }
                });
                this.presentList.forEach((item) => {
                    item.textStatus = course.textStatus;
                    item.courseName = course.courseName;
                    item.liveDate = course.liveDate;
                    item.liveLink = course.liveLink;
                    item.liveTeacher = course.liveTeacher.replace(/,/g, " |");
                    item.liveTimeEnd = course.liveTimeEnd;
                    item.liveTimeStart = course.liveTimeStart;
                    item.statusAttendance = this.$t("manage.present");
                });
                this.absentList.forEach((item) => {
                    item.studyTime = "";
                    item.textStatus = course.textStatus;
                    item.courseName = course.courseName;
                    item.liveDate = course.liveDate;
                    item.liveLink = course.liveLink;
                    item.liveTeacher = course.liveTeacher.replace(/,/g, " |");
                    item.liveTimeEnd = course.liveTimeEnd;
                    item.liveTimeStart = course.liveTimeStart;
                    item.statusAttendance = this.$t("manage.absent");
                });
                const results = this.presentList.concat(this.absentList);
                var headerName = [
                    {
                        key: "courseName",
                        value: "home.courseName",
                    },
                    {
                        key: "liveDate",
                        value: "home.teachingTime",
                    },
                    {
                        key: "liveTimeStart",
                        value: "studySituationList.validityPeriodStart",
                    },
                    {
                        key: "liveTimeEnd",
                        value: "studySituationList.validityPeriodEnd",
                    },
                    {
                        key: "textStatus",
                        value: "home.status",
                    },
                    {
                        key: "studentName",
                        value: "profile.name",
                    },
                    {
                        key: "email",
                        value: "profile.email",
                    },
                    {
                        key: "liveTeacher",
                        value: "manage_student.teacher",
                    },
                    {
                        key: "studyTime",
                        value: "profile.studyTime",
                    },
                    {
                        key: "liveLink",
                        value: "profile.link",
                    },
                    {
                        key: "statusAttendance",
                        value: "manage.statusAttendance",
                    },
                ];
                var params = {
                    header: true,
                    titles: ["studentName", "studyTime", "statusAttendance", "email", "courseName", "liveDate", "liveTimeStart", "liveTimeEnd", "liveTeacher", "liveLink", "textStatus"],
                    data: results,
                    headerName: headerName,
                };
                this.exportCsv(params);
            },
        },
    };
</script>
<style scoped>
    .btn-details-course {
        float: left;
        height: 35px;
        padding: 0px 10px;
        background-color: #0071c5;
        color: #fff;
        border: 0;
        border-radius: 10px;
        font-weight: bold;
        min-width: 200px;
        font-size: 13px;
    }
    .btn-details-course:hover {
        background: #2696ff;
    }
    .btn-details-course-not-list {
        background: #d2d2d2 !important;
        cursor: no-drop;
    }
    .card-avtar {
        width: 160px;
    }
    .card-tt {
        width: calc(100% - 160px);
    }
    .lkt-hiddenText {
        display: -webkit-box !important;
        -webkit-box-orient: vertical !important;
        -webkit-line-clamp: 1 !important;
    }
    .nqt--card-discription {
        display: -webkit-box !important;
        -webkit-box-orient: vertical !important;
        padding: 0 0 0px !important;
        overflow: hidden !important;
        color: #333 !important;
        -webkit-line-clamp: 3 !important;
        line-height: 18px;
        width: 100%;
        margin-bottom: 5px;
    }
    .nqt--card--student {
        cursor: pointer;
        border: 1px solid #d7d7d7;
        /* min-height: 300px; */
    }
    .nqt--card-discription i {
        font-style: unset;
    }
    .nqt--card-discription i.isTeacher {
        color: #00a8ff;
    }
    .nqt--title {
        text-align: center;
        /* margin: 10px auto; */
        text-transform: uppercase;
        height: 36px;
        padding: 2px;
    }
    .non_list {
        height: 40px;
    }
    .stBg .nqt--card-title {
        color: #1f1313;
    }
    .stLn .nqt--card-title {
        color: #da251d;
    }
    .stEnd .nqt--card-title {
        color: #118e07;
    }
    .unactive {
        filter: grayscale(100%);
    }
    .select-new {
        width: 25% !important;
    }
    .select-new.mobile {
        width: 100% !important;
        margin-top: 1rem;
    }
    .dtp {
        margin-top: 20px;
        float: none;
    }
    .dot--lesson_begin {
        background: #1f1313;
    }
    .dot--lesson_learning {
        background: #da251d;
    }
    .dot--lesson_end {
        background: #118e07;
    }

    .noteDot span {
        padding-left: 10px;
        padding-right: 20px;
        cursor: pointer;
        font-size: 16px;
    }

    /* switch */
    .menu-switch-school {
        display: block;
        position: relative;
        width: 46px;
        height: 27px;
        border: 1px solid #dfdfdf;
        outline: 0;
        border-radius: 16px;
        box-sizing: border-box;
        background-color: #dfdfdf;
        transition: background-color 0.1s, border 0.1s;
        cursor: pointer;
    }
    .menu-switch-school:before {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 44px;
        height: 25px;
        border-radius: 15px;
        transition: transform 0.35s cubic-bezier(0.45, 1, 0.4, 1);
    }
    .menu-switch-school:after {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 24px;
        height: 24px;
        border-radius: 15px;
        background-color: #ffffff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
        transition: transform 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
    }
    .menu-switch-school-on {
        border-color: #79c9ff;
        background-color: #79c9ff;
    }
    .lesson_begin.menu-switch-school-on:before {
        border-color: #1f1313;
        background-color: #1f1313;
    }
    .lesson_learning.menu-switch-school-on:before {
        border-color: #da251d;
        background-color: #da251d;
    }
    .lesson_end.menu-switch-school-on:before {
        border-color: #118e07;
        background-color: #118e07;
    }
    .menu-switch-school-on:after {
        transform: translateX(20px);
    }
    .controlType {
        display: flex;
    }
    .controlType .dtp {
        margin-top: 0;
        margin-left: 20px;
    }
    .loading--lesson {
        position: absolute;
    }
    /* toptip */
    /* Tooltip container */
    .tooltip {
        position: relative;
        display: inline-block;
    }

    /* Tooltip text */
    .tooltip .tooltiptext {
        visibility: hidden;
        width: auto;
        background-color: black;
        color: #fff;
        text-align: center;
        padding: 5px;
        border-radius: 6px;

        /* Position the tooltip text - see examples below! */
        position: absolute;
        z-index: 1;
        top: 40%;
    }

    .tooltip .lkt-tooltip {
        top: 83%;
        left: 43%;
        visibility: hidden;
        width: auto;
        background-color: black;
        color: #fff;
        text-align: center;
        padding: 5px;
        border-radius: 6px;

        /* Position the tooltip text - see examples below! */
        position: absolute;
        z-index: 1;
    }

    .tooltip .tooltiptext::after {
        content: " ";
        position: absolute;
        bottom: 100%; /* At the top of the tooltip */
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent black transparent;
    }

    /* Show the tooltip text when you mouse over the tooltip container */
    .uio9:hover .tooltiptext {
        visibility: visible;
    }
    .uio9 {
        -webkit-box-orient: vertical !important;
    }
    .uinqt {
        height: 54px;
    }
    .imgf {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .tooltiptext.pjjj__nqt {
        text-align: unset !important;
    }
    .tooltiptext.lkt-tooltip {
        text-align: unset !important;
    }
    .nqt-pst-a {
        position: absolute !important;
    }
    @media (max-width: 480px) {
        .imgf {
            top: 64% !important;
        }
        .manage--content {
            min-height: 362px !important;
        }
        .nd-gt div {
            flex-wrap: inherit;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/manage/content/attendances.vue